import { FC, useCallback } from 'react';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { updateOpen } from '../store/dialog';
import { RootState } from '../store';

// router
import { useHistory } from 'react-router-dom';

// assets
import style from '../assets/style/layout/hasEmptyFieldsDialog.module.scss';
import dialogStyle from '../assets/style/layout/dialog.module.scss';

// function component
export const HasEmptyFieldsDialog: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { isUserRegistered } = useSelector((state: RootState) => state.user);
  const { isBonusPeriod } = useSelector((state: RootState) => state.custom);

  // 閉じる
  const doClose = useCallback(() => {
    history.push(isUserRegistered ? '/profile/birthMonth' : '/profile');
    dispatch(updateOpen(false)); // 閉じる
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <figure className={style.figure}>
        <img src="/assets/images/shimaenagaChan/please.png" alt="" className={style.image} />
      </figure>
      <p className={style.paragraph}>
        プロフィール更新のお願い
        <br />
        生まれた年と月を登録してね
      </p>
      {isBonusPeriod && (
        <p className={`${style.paragraph} ${style.tada}`}>
          <span className={style.block}>
            <span className={style.shortCopy}>登録すると 今だけ</span>
            <strong className={style.pointGet}>10ポイントGET！</strong>
          </span>
        </p>
      )}
      <button className={dialogStyle.button} type="button" onClick={doClose}>
        登録する
      </button>
    </>
  );
};
